import { Component, OnInit, Input } from "@angular/core";
import { MatBottomSheetRef } from "@angular/material";

@Component({
  selector: "ya-bottomsheetclosebottom",
  templateUrl: "./bottomSheetCloseBottom.component.html",
  styleUrls: ["./bottomSheetCloseBottom.component.scss"]
})
export class BottomSheetCloseBottomComponent implements OnInit {
  @Input() bottomSheetRef: MatBottomSheetRef<any>;

  constructor() { }

  ngOnInit() {
  }

  public closeModal() {
    const me = this;
    me.bottomSheetRef.dismiss();
  }
}
